export default {
  namespaced: true,
  state: {
    opened: false,
    view: null,
    value: null
  },
  mutations: {
    value (state, value) {
      state.value = value
    },
    with (state, { view, value }) {
      state.opened = true
      state.view = view
      state.value = value
    },
    open (state, view) {
      state.opened = true
      state.view = view
    },
    close (state) {
      state.opened = false
      state.view = null
      state.value = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/modal.js